module.exports = __webpack_public_path__ + "static/img/蒙版分组.301da68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner2/蒙版分组.png
// module id = Hlp/
// module chunks = 1